import { useCookies } from "react-cookie";

const useRequestHeader = (token = "", contentType = "") => {
  const [cookies] = useCookies([]);

  const requestHeader = {
    client: "user",
    "client-ag": `wa-${process.env.REACT_APP_VERSION}`,
    "x-token": cookies?.utt,
  };
  if (token === "noToken") delete requestHeader["x-token"];
  if (contentType != "") requestHeader["Content-Type"] = contentType;

  return requestHeader;
};

export default useRequestHeader;
